import * as t from "./types";
import * as actions from "./action";

/* Account */
export const getAlertsAction = (
  payload: t.GetAlertsRequestType
): t.GetAlertsActionType => {
  return {
    type: actions.GET_ALERTS,
    payload,
  };
};
